var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9BA0B1",
    fillRule: "evenodd",
    d: "M15.795 8.221c-.392-.39-.394-1.022-.004-1.414.39-.392 1.022-.394 1.414-.004l2 1.988c.392.39.394 1.022.004 1.414l-2 2.012c-.39.392-1.022.393-1.414.004-.392-.39-.394-1.022-.004-1.414l.303-.307h-5.097c-.55 0-.997-.444-.997-1 0-.552.447-1 .997-1h5.079l-.281-.279zM8 18.5v2.214c0 1.056-1.045 1.644-1.948 1.086L.896 18.61C.369 18.285 0 17.621 0 17.004V1.996c0-.32.096-.596.254-.811.014-.036.033-.07.059-.103C.587.728 1.018.5 1.5.5h11c.826 0 1.5.672 1.5 1.496V4.5c0 .552-.448 1-1 1s-1-.448-1-1v-2l-7.489-.004 2.593 1.603c.527.326.896.99.896 1.608V16.5h4v-2c0-.552.448-1 1-1s1 .448 1 1v2.504c0 .828-.673 1.496-1.5 1.496H8zM6.005 5.799L2 3.31v13.68l4.005 2.439V5.799z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.02a0424f107e853838e5ff9fa35e9ec8.svg";
export { ForwardRef as ReactComponent };